export default {
    mounted() {
        if ($(this.$el).hasClass('modal')) {
            $(this.$el).on("hidden.bs.modal", () => {
                if ($(".modal.in").length > 0) {
                    $("body").addClass('modal-open')
                }
            })
        }

    }
}